var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    preserveAspectRatio: "xMidYMid",
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "0 0"
    },
    viewBox: "0 0 100 100"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0F172A"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    begin: "-0.67s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "95;35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-0.67s",
    dur: "1s",
    keyTimes: "0;0.2;1",
    repeatCount: "indefinite",
    values: "0;1;1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    begin: "-0.33s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "95;35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "-0.33s",
    dur: "1s",
    keyTimes: "0;0.2;1",
    repeatCount: "indefinite",
    values: "0;1;1"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 50,
    r: 4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "cx",
    begin: "0s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "95;35"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0s",
    dur: "1s",
    keyTimes: "0;0.2;1",
    repeatCount: "indefinite",
    values: "0;1;1"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#6a25df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 50V20a30 30 0 0 0 0 60Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 50H5a30 30 0 0 0 60 0Z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "1s",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 50 50;45 50 50;0 50 50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35 50H5a30 30 0 0 1 60 0Z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "1s",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 50 50;-45 50 50;0 50 50"
  })))));
};
export default SvgLoader;